import { getFilters, removeFilterGroup, setFilterGroupValue } from "../filter"

export const handleSelectInputEvent = (element: HTMLSelectElement) => {
    const group = element.getAttribute("data-seo-group") as string
    const [rangeSelect1, rangeSelect2] = document.querySelectorAll<HTMLSelectElement>(
        `select[data-seo-group="${group}"]`,
    )

    // single selects
    if (rangeSelect2 === undefined) {
        return
    }

    // multiple selects
    if (rangeSelect1.value || rangeSelect2.value) {
        setFilterGroupValue(group, [rangeSelect1.value, rangeSelect2.value])
    } else {
        removeFilterGroup(group)
    }
}

export function resetFilterSelects() {
    const elements = Array.from(document.querySelectorAll<HTMLSelectElement>(".custom.select select"))
    for (const element of elements) {
        element.value = ""
    }
}

export function updateFilterSelectInDom(group: string) {
    const [select1, select2] = document.querySelectorAll<HTMLSelectElement>(`select[data-seo-group="${group}"]`)
    select1.value = getFilters()[group][0]
    select2.value = getFilters()[group][1]
}
